import { Action } from 'redux';

import { EditPublishedConnection } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface EditPublishedConnectionReduxAction extends Action {
  readonly publishedConnection: IContentInfo;
}

export function editPublishedConnection(publishedConnection: IContentInfo): EditPublishedConnectionReduxAction {
  return {
    type: EditPublishedConnection,
    publishedConnection
  };
}
